import { DividendYieldValues, DividendYieldResult } from './types';

export function calculateDividendYield(values: DividendYieldValues): DividendYieldResult {
  const { pricePerShare, dividendPerShare } = values;

  if (pricePerShare <= 0 || dividendPerShare < 0) {
    return { yield: 0 };
  }

  return { yield: dividendPerShare / pricePerShare };
}


